/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const hubSpotLinkDataSchema = z.object({
	hubspotCompanyId: z.string(),
	company: z.object({
		id: z.string(),
		name: z.string().nullable(),
		domain: z.string().nullable(),
		city: z.string().nullable(),
		country: z.string().nullable(),
	}).nullable(),
	linkedAt: z.iso.datetime(),
})

export type HubSpotLinkDataSchema = z.infer<typeof hubSpotLinkDataSchema>
